import React from 'react';

import styles from './Footer.module.scss';
import {Grid, Text} from '../../../../../../components';

export interface Props {}

type State = {};
type ComposedProps = Props;

export default class Footer extends React.PureComponent<ComposedProps, State> {
  render() {
    return (
      <footer className={styles.Footer}>
        <Grid>
          <Grid.ScreenWidth>
            <Text size="small" italic color="var(--color-primary)">
              Copyright © {new Date().getFullYear()} Ekipo
            </Text>
          </Grid.ScreenWidth>
        </Grid>
      </footer>
    );
  }
}
